<script setup lang="ts">
import { nextTick, ref } from 'vue'

import { useKeepTabbingFocus } from '../../../composables/use-keep-tabbing-focus'
import Icon from '../../../components/shared/Icon.vue'

const searchPhrase = ref('')
const headerSearchForm = ref<HTMLFormElement | null>(null)
const headerSearchOpener = ref<HTMLAnchorElement | null>(null)
const headerSearchInput = ref<HTMLInputElement | null>(null)

const { keepTabbingFocus, removeTabbingEventListeners } = useKeepTabbingFocus()

const toggleSearch = () => {
  const showSearch = document.body.classList.toggle('bx-js-show-search')
  if (showSearch) {
    headerSearchInput.value?.focus()
    keepTabbingFocusInHeaderSearch()
  }
}

const submitSearch = () => {
  window.location.href = `/suche?query=${encodeURIComponent(searchPhrase.value.trim())}`
}

const keepTabbingFocusInHeaderSearch = () => {
  nextTick(() => {
    removeTabbingEventListeners()
    if (!headerSearchForm.value) return
    keepTabbingFocus(headerSearchForm.value, ['input, a'], 0, () => {
      removeTabbingEventListeners()
      toggleSearch()
      headerSearchOpener.value?.focus()
    })
  })
}
</script>

<template>
  <div class="bx-header__search bx-typo--header-search">
    <a ref="headerSearchOpener"
       aria-label="Suche öffnen"
       class="icon icon--header-search"
       tabindex="0"
       @click="toggleSearch()"
       @keyup.enter="toggleSearch()">
      <svg><use href="#search" /></svg>
    </a>
    <form ref="headerSearchForm"
          class="bx-form bx-typo--form bx-form--search-header bx-typo--form-search-header"
          onsubmit="return false;"
          @submit="submitSearch()">
      <input id="bx-header-search-input"
             ref="headerSearchInput"
             v-model="searchPhrase"
             type="search"
             class="bx-form__input"
             title="AUTO ZEITUNG durchsuchen"
             placeholder="AUTO ZEITUNG durchsuchen">
      <button aria-label="Suchen"
              class="bx-form__search-submit"
              tabindex="-1"
              @click="submitSearch()"
              @keyup.enter="submitSearch()">
        <Icon name="search" />
      </button>
      <a aria-label="Suche schliessen"
         class="icon icon--header-close"
         tabindex="0"
         @click="toggleSearch()"
         @keyup.enter="toggleSearch()">
        <svg><use href="#close" /></svg>
      </a>
    </form>
  </div>
</template>
